var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"anchor-navigation"},_vm._l((_vm.anchorLinks),function(item,index){return _c('div',{key:index,staticClass:"anchor-links-item"},[_c('a',{attrs:{"href":`#${item.link}`}},[_vm._v(_vm._s(item.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }